export default __webpack_public_path__ + "static/webinarBanner-e04cf3504219ba024215186d67c74e23.png";